// lib/apiError.ts — извлечение человекочитаемого сообщения из ошибок API (R24 / D24).

/** Структура axios-подобной ошибки с телом ответа сервера. */
interface ApiErrorLike {
  response?: {
    data?: unknown;
  };
}

/**
 * Извлекает {@code message} из тела ошибки API (Spring ErrorResponse / DealErrorResponse),
 * иначе возвращает {@code fallback}.
 * <p>
 * Используется для error surfacing в UI: пользователь видит текст от backend
 * (например, причину отказа state machine), а не generic «Request failed with status code 400».
 *
 * @param error    ошибка мутации/запроса (unknown — axios-код мутирует типы).
 * @param fallback текст по умолчанию, если message от сервера отсутствует или не строка.
 * @return message от сервера или fallback.
 */
export function extractApiErrorMessage(error: unknown, fallback: string): string {
  const data = (error as ApiErrorLike | null)?.response?.data;
  if (data && typeof data === 'object' && 'message' in data) {
    const message = (data as { message?: unknown }).message;
    if (typeof message === 'string' && message.length > 0) {
      return message;
    }
  }
  return fallback;
}
